import { render } from "./OutletDetails.vue?vue&type=template&id=80ed5d72"
import script from "./OutletDetails.vue?vue&type=script&lang=js"
export * from "./OutletDetails.vue?vue&type=script&lang=js"

import "./OutletDetails.vue?vue&type=style&index=0&id=80ed5d72&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__